<ul>
  <li>{{ detail.title }}</li>
  <li>{{ detail.referenceProduit }}</li>
  <br />
  <li>{{ detail.referenceInterne }}</li>
  <li>Session {{ detail.referenceSession }}</li>
  <br />
  <li><span class="k-icon k-i-calendar"></span> Début le {{ detail.dateBegin }}</li>
  <li><span class="k-icon k-i-calendar"></span> Fin le {{ detail.dateEnd }}</li>
  <br />
  <li><span class="k-icon k-i-marker-pin"></span>{{ detail.lieuName }}</li>
  <li>{{ detail.lieuAddress }}</li>
  <br />
  <li>Responsable administratif: {{ detail.nameResponsible }}</li>
</ul>
<div style="margin: 25px 0 25px 0">
  <p style="text-align: center">
    <button kendoButton [primary]="true" (click)="seeDetails()" [look]="'outline'">
      Voir détails
    </button>
  </p>
  <p class="uk-text-center" style="margin-bottom: .3rem;" *ngIf="!isClicked">
    <button
      kendoButton
      class="colored-text uk-text-uppercase button-grey-light"
      style="margin-left: .2rem; margin-right: .3rem;"
      [primary]="false"
      (click)="refuse()"
    >
      <span uk-icon="close"></span>&nbsp;Je décline
    </button>
    <button
      kendoButton
      class="colored-text uk-text-uppercase"
      style="margin-left: .2rem; margin-right: .3rem;"
      [primary]="true"
      (click)="accept()"
    >
      <span uk-icon="check"></span>&nbsp;J'accepte
    </button>
  </p>
</div>
